import React from "react";

// Lazy load components
const IconDotsVertical = React.lazy(
  () =>
    import(
      "../icons/IconDotsVertical" /* webpackChunkName: "iconDotsVertical" */
    )
);

interface MoreItemsDropdownProps {
  children: React.ReactElement;
}

export const MoreItemsDropdown = ({ children }: MoreItemsDropdownProps) => {
  return (
    <div className="col-auto">
      <div className="dropdown position-static">
        <span
          className="card-dropdown"
          data-toggle="dropdown"
          aria-expanded="true"
        >
          <IconDotsVertical />
        </span>
        <div
          className="dropdown-menu dropdown-menu-end"
          style={{
            position: "absolute",
            inset: "0px auto auto 0px",
            margin: "0px",
            transform: "translate(-154px, 22px)",
          }}
          data-popper-placement="bottom-end"
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default MoreItemsDropdown;
